import { Phone, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./primitives";
import { HOTLINES } from "@/lib/content";

export default function Hotlines() {
  return (
    <section id="hotlines" data-testid="hotlines-section" className="bg-sand py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>Talk to someone now</Eyebrow>
            <h2 className="mt-6 font-serif text-4xl font-medium leading-tight tracking-tight text-ink sm:text-5xl">
              Help is one call away
            </h2>
            <p className="mt-6 text-base leading-relaxed text-stone sm:text-lg">
              These are real, confidential lines serving survivors across California and nationwide.
              You never have to give your name, and you can hang up at any time. When you're ready,
              they're here.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
          {HOTLINES.map((h, i) => (
            <Reveal key={h.name} delay={i * 0.08}>
              <a
                href={h.href}
                data-testid={`hotline-card-${i}`}
                className="group flex h-full flex-col justify-between rounded-3xl bg-bone p-8 shadow-[0_8px_30px_rgba(45,48,42,0.06)] transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(45,48,42,0.12)]"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terracotta text-white">
                      <Phone className="h-5 w-5" strokeWidth={2.2} />
                    </span>
                    <ArrowUpRight className="h-5 w-5 text-sage transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
                  </div>
                  <h3 className="mt-6 font-serif text-2xl font-medium text-ink">{h.name}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-stone">{h.hint}</p>
                </div>
                <p className="mt-6 font-serif text-3xl font-medium tracking-tight text-terracotta">
                  {h.number}
                </p>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
